module.exports = __webpack_public_path__ + "img/DerVogelIstImmerDabei.78bf274d.jpg";